<template>
  <div id="contenedor-contrato-firma-nueva">
    <v-card>
        <v-card-title>
          Registrar nueva firma
        </v-card-title>
        <v-card-text
          style="max-height: 300px;">
         <v-form
            v-model="formularioValido"
            ref="registrarNuevaFirma">
            <auto-complete
                v-model="firma.idFuncionario"
                label="Funcionario"
                :items="getFuncionarios"
                item-text="nombre"
                item-value="id"
                :rules="[mixReglas.requerido]">
            </auto-complete>
            <custom-text-field
                v-model.number="firma.orden"
                type="number"
                label="Orden"
                :rules="[mixReglas.requerido]">
            </custom-text-field>
        </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cancelar"
            @click="cerrar()">
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            @click="guardar()"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>

  </div>
</template>

<script>
import Funcionarios from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import AutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixFirmas from './mixFirmas';

export default {
  name: 'contratoFirmaNueva',
  mixins: [mixFirmas],
  components: {
    AutoComplete,
    CustomTextField,
    CustomButton,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      firma: {
        idContrato: this.idContrato,
        idFuncionario: '',
        orden: 1,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevaFirma.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      this.mixAgregarContratoFirma();
    },
  },
  apollo: {
    funcionarios: {
      query: Funcionarios,
    },
  },
  computed: {
    getFuncionarios() {
      if (!this.funcionarios) return [];
      return this.funcionarios;
    },
  },
};
</script>

<style lang="scss">

</style>
